import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkStatus } from '../../../util/util';
import Select from 'react-select';
import map from 'lodash/map';
import filter from 'lodash/filter';
import { AlertBar, AlertConfirm, Alert, AlertCommit } from '../../Modals/AlertBar';
import { withNamespaces } from 'react-i18next';
import moment from "moment";

class MaintenanceInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            maintenanceInfoList: [],
            selectedDevice: '',
            carLicenceNo: '',
            selectedTemplate: '',

            device_id: 0,
            device_no: '',
            maList: {
                ma_name: '',
                measure_type_id: 4,
                alert_repeat: 0,
                is_email_alert: false,
                is_line_alert: false,
                counter: 0,
                next_alert_when: '',
                ma_list_id: ''
            },
            measureTypeList: [],
            deviceNoList: [],
            measureUnit: 'วัน',
            maListOnClick: [],
            alertHistory: [],
            isSaveTemplate: false,
            templateName: '',
            templateList: [],
            isMoveData: false,
            selectedDeviceMoveData: []
        }
    }

    componentWillMount() {
        const { isAddAlertMA, carNumber } = this.props;
        this.setState({ isAddAlertMA, selectedDevice: carNumber.label || '' });
    }

    componentDidMount(){
        const { carNumber } = this.props;
        this.getActiveDeviceUserRelated();
        this.getMAMeasureTypeList();
        this.getMATemplateList();
        if (carNumber.value > 0) {
            this.onClickSearchDeviceNo(carNumber);
        }
    }

    getMATemplateList = () => {
        const { user_id, user_name, token } = this.props;
        fetch('http://203.150.199.244/api/admin/getMATemplateList', {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({"filter": ''})
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                let objList = [];
                data.RESULT_DATA.map((obj, key) => {
                    objList.push({
                        name: obj.name,
                        template_id: obj.template_id,
                        ma_list: obj.ma_list
                    });
                });
                this.setState({templateList: objList});
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    getActiveDeviceUserRelated = () => {
        const { user_id, user_name, token } = this.props;
        fetch('http://203.150.199.244/api/admin/getActiveDeviceUserRelated/1000', {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                let objList = [];
                data.RESULT_DATA.map((obj, key) => {
                    objList.push({
                        deviceId: obj.device_id,
                        deviceNo: obj.device_no
                    });
                });
                this.setDeviceList(objList);

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    getMAMeasureTypeList = () => {
        const { user_id, user_name, token } = this.props;
        fetch('http://203.150.199.244/api/admin/getMAMeasureTypeList', {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                let objList = [];
                data.RESULT_DATA.map((obj, key) => {
                    objList.push({
                        measure_type_id: obj.measure_type_id,
                        measureTypeName: obj.measure_type,
                        measureUnit: obj.measure_unit
                    });
                });
                this.setMeasureList(objList);

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }


    setDeviceList = (objList) => {
        this.setState({ deviceNoList: objList });
    }

    setMeasureList = (objList) => {
        this.setState({ measureTypeList: objList });
    }

    handleChange = (selectedDevice) => {
        this.setState({ selectedDevice });
    }

    handleChangeMoveData = (selectedDeviceMoveData) => {
        this.setState({ selectedDeviceMoveData });
    }

    handleChangeTemplate = (selectedTemplate) => {
        this.setState({ selectedTemplate });
    }

    onClickSearchDeviceNo = (selectedDevice) => {
        const {
            user_name,
            user_id,
            token
        } = this.props;

        this.setState({
            carLicenceNo: selectedDevice.label,
            device_no: selectedDevice.value
        });

        fetch(`http://203.150.199.244/api/admin/getMaintenanceInfo/${selectedDevice.value}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => {
                return checkStatus(response)
            })
            .then(data => {
                let objList = []
                data.RESULT_DATA.map((obj, key) => {
                    objList.push(obj.ma_list);
                });

                let objList2 = []
                data.RESULT_DATA.map((obj, key) => {
                    objList2.push(obj.alert_history);
                });

                this.setState({
                    maintenanceInfoList: objList[0] || [],
                    alertHistory: objList2[0] || [],
                    nextAlertWhen: []
                });
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }

    onClickUseTemplate = (selectedTemplate) => {
        const { templateList } = this.state;
        // console.log('selectedTemplate:', selectedTemplate);
        let maTemplate = [];
        if (selectedTemplate.value > 0){
            maTemplate = filter(templateList, (n) => n.template_id === selectedTemplate.value);
            // console.log('maTemplate:', maTemplate);
            this.setState({ maintenanceInfoList: [] }, () => this.setState({ maintenanceInfoList: maTemplate[0].ma_list}));
        }
    }

    onChangeSelectedMeasure = (e, index) => {
        const { measureTypeList, maintenanceInfoList } = this.state;
        const values = e.target.value;
        let maUnit = [];
        if (values.length > 0) {
            maUnit = filter(measureTypeList, (n) => n.measureTypeName === values);
            maintenanceInfoList[index].measure_unit = maUnit[0].measureUnit;
            this.setState({maintenanceInfoList});
        }
        maintenanceInfoList[index].measure_type_id = maUnit[0].measure_type_id;
        this.setState({maintenanceInfoList});
        // onChangeAlertRepeat
        // onBlur={(e) => this.onChangeAlertRepeatCounter(e.target.value, maintenanceInfoList[key].counter , key)}
        this.onChangeAlertRepeatCounter(maintenanceInfoList[index].alert_repeat, maintenanceInfoList[index].counter , index)
    }

    onChangeMaName = (data, index) => {
        const { maintenanceInfoList } = this.state;
        maintenanceInfoList[index].ma_name = data;
        this.setState({maintenanceInfoList});
    }

    // onChangeAlertRepeat = (data, index) => {
    //     const { maintenanceInfoList } = this.state;
    //     maintenanceInfoList[index].alert_repeat = data;
    //     console.log('maintenanceInfoList:', maintenanceInfoList[index]);
    //     if (maintenanceInfoList[index].measure_type_id === 2 || maintenanceInfoList[index].measure_type_id === 3) {
    //         console.log('maintenanceInfoList[index].alert_repeat:', maintenanceInfoList[index].alert_repeat);
    //         console.log('maintenanceInfoList[index].counter:', maintenanceInfoList[index].counter);
    //         maintenanceInfoList[index].next_alert_when = maintenanceInfoList[index].alert_repeat - maintenanceInfoList[index].counter;
    //     } else if (maintenanceInfoList[index].measure_type_id === 4) {
    //         maintenanceInfoList[index].next_alert_when = this.isMeasureType4(maintenanceInfoList[index].alert_repeat, maintenanceInfoList[index].counter);
    //     }
    //     this.setState({maintenanceInfoList});
    // }

    onChangeAlertRepeatCounter = (alertRepeat, counter, index) => {
        const { maintenanceInfoList } = this.state;
        maintenanceInfoList[index].alert_repeat = alertRepeat;
        maintenanceInfoList[index].counter = counter;
        if (maintenanceInfoList[index].measure_type_id === 2 || maintenanceInfoList[index].measure_type_id === 3) {
            maintenanceInfoList[index].next_alert_when = maintenanceInfoList[index].alert_repeat - maintenanceInfoList[index].counter;
        } else if (maintenanceInfoList[index].measure_type_id === 4) {
            maintenanceInfoList[index].next_alert_when = this.isMeasureType4(maintenanceInfoList[index].alert_repeat, maintenanceInfoList[index].counter);
        }
        this.setState({maintenanceInfoList});
    }

    isMeasureType4 = (alertRepeat, counter) => {
        const duration = moment.duration({'days' : alertRepeat - counter});
        return moment().add(duration).format('DD/MM/YYYY');
    }

    onChangeRemark = (data, index) => {
        const { maintenanceInfoList } = this.state;
        maintenanceInfoList[index].remark = data;
        this.setState({maintenanceInfoList});
    }

    onClickAddMaList = () => {
        const { t } = this.props;
        const { maintenanceInfoList, carLicenceNo, maList } = this.state;
        const ma = {
                ma_name: '',
                measure_type_id: 4,
                alert_repeat: 0,
                is_email_alert: false,
                is_line_alert: false,
                counter: 0,
                next_alert_when: '',
                ma_list_id: ''
        }
        if (carLicenceNo && carLicenceNo.length > 0 && maintenanceInfoList) {
            maintenanceInfoList.push(ma);
            this.setState({maintenanceInfoList});
        } else {
            Alert(t('กรุณาเลือกทะเบียนรถก่อน'));
        }
    }

    onClickDeleteRow(key) {
        const { maintenanceInfoList } = this.state;
        const maintenanceInfoListObj = maintenanceInfoList;

        maintenanceInfoListObj.splice(key, 1);
        this.setState({ maintenanceInfoList: [] }, () => this.setState({ maintenanceInfoList: maintenanceInfoListObj }));
    }

    // onChangeCounter = (data, index) => {
    //     const { maintenanceInfoList } = this.state;
    //     maintenanceInfoList[index].counter = data;
    //     maintenanceInfoList[index].next_alert_when = maintenanceInfoList[index].alert_repeat - maintenanceInfoList[index].counter;
    //     if (maintenanceInfoList[index].measure_type_id === 4) {
    //         maintenanceInfoList[index].next_alert_when = this.isMeasureType4(maintenanceInfoList[index].alert_repeat, maintenanceInfoList[index].counter);
    //     }
    //     this.setState({maintenanceInfoList});
    // }

    onChangeMailAlert = (data, index) => {
        const { maintenanceInfoList } = this.state;
        maintenanceInfoList[index].is_email_alert = data;
        this.setState({maintenanceInfoList});
    }

    onChangeLineAlert = (data, index) => {
        const { maintenanceInfoList } = this.state;
        maintenanceInfoList[index].is_line_alert = data;
        this.setState({maintenanceInfoList});
    }

    onClickSubmit = () => {
        const { maintenanceInfoList, carLicenceNo, device_no } = this.state;
        const {
            t,
            user_name,
            user_id,
            token
        } = this.props;
        // console.log('maintenanceInfoList onClickSubmit:', maintenanceInfoList);
        if (carLicenceNo) {
            AlertConfirm(t('เพิ่มระบบซ่อมบำรุง'), t('คุณต้องการบันทึกข้อมูลหรือไม่')).then(isOk => {
                if (isOk) {
                    let maintenanceInfoLists = []
                    maintenanceInfoList.map((obj, key) => {
                        // delete obj.measure_unit
                        delete obj.measure_type
                        delete obj.is_alert
                        delete obj.last_alert_dtm
                        maintenanceInfoLists.push(obj);
                        // this.setState({maintenanceInfoList: maintenanceInfoLists})
                    });
                    fetch("http://203.150.199.244/api/admin/updateMaintenance", {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token
                        },
                        body: JSON.stringify({
                            "device_id": device_no,
                            "device_no": carLicenceNo,
                            "ma_list": maintenanceInfoLists
                        })
                    })
                        .then(response => {
                            return checkStatus(response)
                        })
                        .then(data => {
                            // alert_repeat less than couter
                            if (data.RESULT_MESSAGE === 'Fail') {
                                AlertCommit(false, t('กรุณาเพิ่มรายการอย่างน้อย 1 รายการ'));
                            } else if (data.RESULT_MESSAGE === 'Please spacify Name') {
                                AlertCommit(false, t('กรุณาใส่ชื่อรายการให้ครบ'));
                            } else if (data.RESULT_MESSAGE === 'Please spacify alert repeat') {
                                AlertCommit(false, t('กรุณาใส่ข้อมูลแจ้งทุกๆ'));
                            } else if (data.RESULT_MESSAGE === 'Please spacify next alert') {
                                AlertCommit(false, t('แจ้งทุกๆ หรือ ค่าปัจจุบัน ไม่ถูกต้อง'));
                            } else if (data.RESULT_MESSAGE === 'alert_repeat less than couter.') {
                                AlertCommit(false, t('ค่าเตือนเมื่อถึงต้องมากกว่า 0'));
                            } else if (data.RESULT_MESSAGE === 'TypeError'){
                                AlertCommit(false, t('ค่าเตือนเมื่อถึงมีค่าติดลบ'));
                            } else if (data.RESULT_STATUS === '000') {
                                AlertCommit(true, '');
                            }
                        })
                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                        });
                }
            });
        } else {
            Alert(t('กรุณาเลือกป้ายทะเบียน'));
        }
    }

    onClickSaveTemplate = () => {
        const { t } = this.props;
        const { maintenanceInfoList } = this.state;
        if (maintenanceInfoList && maintenanceInfoList.length > 0) {
            console.log('k1:::');
            this.setState({isSaveTemplate: true});
        } else {
            Alert(t('กรุณาเพิ่มรายการอย่างน้อย 1 รายการ'));
        }
    }

    onSubmitNewTemplate = () => {
        const { maintenanceInfoList, templateName, selectedDevice } = this.state;
        const {
            t,
            user_name,
            user_id,
            token
        } = this.props;
        if(templateName && templateName.length > 0) {
            AlertConfirm(t('เพิ่มแม่แบบระบบซ่อมบำรุง'), t('คุณต้องการบันทึกข้อมูลหรือไม่')).then(isOk => {
                if (isOk) {
                    let maintenanceInfoLists = []
                    maintenanceInfoList.map((obj, key) => {
                        // delete obj.measure_unit
                        delete obj.measure_type
                        delete obj.is_alert
                        delete obj.last_alert_dtm
                        maintenanceInfoLists.push(obj);
                    });
                    fetch("http://203.150.199.244/api/admin/newMATemplate", {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token
                        },
                        body: JSON.stringify({
                            "name": templateName,
                            "ma_list": maintenanceInfoLists
                        })
                    })
                        .then(response => {
                            return checkStatus(response)
                        })
                        .then(data => {
                            if (data.RESULT_STATUS === '999') {
                                AlertCommit(false, '');
                            }
                            else if (data.RESULT_STATUS === '000') {
                                AlertCommit(true, '');
                            }
                        })
                        .then(() => this.setState({isSaveTemplate: false}))
                        .then(() => this.onClickSearchDeviceNo(selectedDevice))
                        .then(() => this.getMATemplateList())
                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                        });
                }
            });
        } else {
            alert('กรุณาใส่ชื่อแม่แบบ');
        }

    }

    onClickMoveData = () => {
        this.setState({ isMoveData: true });
    }

    onSubmitMoveData = (selectedDeviceMoveData) => {
        const {
            t,
            user_name,
            user_id,
            token
        } = this.props;
        const {selectedDevice} = this.state;
        const device1 = selectedDevice.value || 0;
        const device2 = selectedDeviceMoveData.value || 0;
        if (device1 === 0 || device2 === 0) {
            Alert(t('กรุณาเลือกทะเบียนรถหลักและทะเบียนรถสำหรับย้ายก่อน'));
        } else if (device1 === device2) {
            Alert(t('ข้อมูลทะเบียนซ้ำกัน  กรุณาเปลี่ยนใหม่'));
        } else if (device1 !== device2) {
            AlertConfirm(t('เพิ่มระบบซ่อมบำรุง'), t('คุณต้องการบันทึกข้อมูลหรือไม่')).then(isOk => {
                if (isOk) {
                    fetch(`http://203.150.199.244/api/admin/moveMaintenance/${device1}/${device2}`, {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token
                        },
                        body: JSON.stringify({})
                    })
                        .then(response => {
                            return checkStatus(response)
                        })
                        .then(data => {
                            if (data.RESULT_STATUS === '999') {
                                AlertCommit(false, t('โปรดกรอกข้อมูลใหม่อีกครั้ง'));
                            } else if (data.RESULT_STATUS === '000') {
                                AlertCommit(true, '');
                                this.setState({selectedDevice: '', selectedDeviceMoveData: []})
                            }
                        })
                        .then(() =>  this.onClickSearchDeviceNo(selectedDeviceMoveData))
                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                        });
                }
            });
        }
    }

    render() {
        const {
            maintenanceInfoList,
            isAddAlertMA,
            selectedDevice,
            selectedTemplate,
            deviceNoList,
            carLicenceNo,
            measureTypeList,
            alertHistory,
            isSaveTemplate,
            templateList,
            isMoveData,
            selectedDeviceMoveData
        } = this.state;
        const { t, onClickAddAlertMA } = this.props;
        let dataLoop;
        const dataList = map(deviceNoList, (dataEach) => {
            dataLoop = {
                value: dataEach.deviceId,
                label: dataEach.deviceNo
            };
            return dataLoop;
        });

        let dataLoop2;
        const dataListMoveData = map(deviceNoList, (dataEach) => {
            dataLoop2 = {
                value: dataEach.deviceId,
                label: dataEach.deviceNo
            };
            return dataLoop2;
        });

        let templateLoop;
        const templateLists = map(templateList, (data) => {
            templateLoop = {
                value: data.template_id,
                label: data.name
            };
            return templateLoop;
        });

        return(
            <div className="gray-panel" >
                <div className="card">
                    <div className="card-header">
                        <h5 style={{paddingLeft: '1em'}}>
                            <i
                                onClick={onClickAddAlertMA}
                                className="fa fa-arrow-left"
                                aria-hidden="true"
                                style={{color: '#7386D5',cursor: 'pointer'}} />
                            {isAddAlertMA ? t('เพิ่ม') : t('แก้ไข')} {t('รายการซ่อมบำรุง')}
                        </h5>
                    </div>
                        <div className="card-body">

                            <div className="col-md-12">
                                <h1 className="page-header">
                                    <i style={{color: '#7386D5'}}>{carLicenceNo ? `${t('หมายเลขทะเบียน')}  ${carLicenceNo}` : ''}</i>
                                </h1>
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-md-6 row">
                                    <div className="col-md-8 row">
                                        <div className="col-md-8" style={{fontSize: '14px'}}>
                                            <Select
                                                value={selectedDevice}
                                                onChange={this.handleChange}
                                                options={dataList}
                                                placeholder={t('เลือกเลขทะเบียนรถ')}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <button
                                                type="button"
                                                className="fas fa-search btn btn-info"
                                                style={{ width: '48px', height: '36px' }}
                                                onClick={() => {this.setState({maintenanceInfoList: []}), this.onClickSearchDeviceNo(selectedDevice)}}
                                            />
                                        </div>
                                </div>
                                </div>
                                <div className="col-md-6 row">
                                    <div className="col-md-8 row">
                                        <div className="col-md-8" style={{fontSize: '14px'}}>
                                            <Select
                                                value={selectedTemplate}
                                                onChange={this.handleChangeTemplate}
                                                options={templateLists}
                                                placeholder={t('เลือกจาก Template')}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <button
                                                type="button"
                                                className="fas fa-search btn btn-info"
                                                style={{ width: '48px', height: '36px' }}
                                                onClick={() => {this.setState({maintenanceInfoList: []}), this.onClickUseTemplate(selectedTemplate)}}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className=" mx-auto">
                                <div className="col-md-12 table-responsive">
                                    <div style={{textAlign:'right'}}>
                                        <button className="btn btn-info btn-xs" onClick={() => this.onClickAddMaList()} ><span className="fa fa-plus" /></button>
                                    </div>
                                    <table className="table table-bordred table-striped table-hover " style={{fontSize: '14px'}}>
                                        <thead >
                                            <tr>
                                                <th rowSpan={2} style={{width:'20px'}}>#</th>
                                                <th rowSpan={2} style={{width:'150px', textAlign: 'center'}}>{t('รายการ')}</th>
                                                <th rowSpan={2} style={{width:'150px', textAlign: 'center'}}>{t('วัดตาม')}</th>
                                                <th rowSpan={2} style={{width:'80px', textAlign: 'center'}}>{t('แจ้งทุกๆ')}</th>
                                                <th rowSpan={2} style={{width:'30px'}}></th>
                                                <th rowSpan={2} style={{width:'120px', textAlign: 'center'}}>{t('ค่าปัจจุบัน')}</th>
                                                <th rowSpan={2} style={{width:'30px'}}></th>
                                                <th rowSpan={2} style={{width:'120px', textAlign: 'center'}}>{t('เตือนเมื่อถึง')}</th>
                                                <th rowSpan={2} style={{width:'30px'}}></th>
                                                <th rowSpan={2} style={{width:'120px', textAlign: 'center'}}>{t('หมายเหตุ')}</th>
                                                {/*<th rowSpan={2} style={{width:'30px'}}></th>*/}
                                                <th colSpan={2}>{t('เตือนด้วย')}</th>
                                                <th rowSpan={2} style={{width:'50px', textAlign: 'right'}}></th>

                                            </tr>
                                            <tr>
                                                <th style={{width:'50px'}}>Mail</th>
                                                <th style={{width:'50px'}}>Line</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        { maintenanceInfoList &&
                                            maintenanceInfoList.map((data, key) => {
                                                return (
                                                    <tr key={key}>
                                                        <td>{key + 1}</td>
                                                        <td>
                                                            <input
                                                                style={{background: 'rgba(255,255,255,0.4)', border:'none', textAlign: 'center'}}
                                                                name="maName"
                                                                className="form-control"
                                                                type="text"
                                                                defaultValue={data.ma_name}
                                                                onChange={(e) => this.onChangeMaName(e.target.value, key)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <select
                                                                name="measureType"
                                                                className="form-control"
                                                                defaultValue={maintenanceInfoList[key].measure_type}
                                                                onChange={(e) => this.onChangeSelectedMeasure(e, key)}>
                                                                {
                                                                    measureTypeList.map((item) => {
                                                                        return(
                                                                            <option
                                                                                    key={item.measure_type_id}
                                                                                    name={item.measureTypeName}>
                                                                                {item.measureTypeName}
                                                                            </option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input
                                                                style={{background: 'rgba(255,255,255,0.4)', border:'none', textAlign: 'center'}}
                                                                name="alertRepeat"
                                                                className="form-control"
                                                                type="text"
                                                                defaultValue={maintenanceInfoList[key].alert_repeat}
                                                                // onBlur={(e) => this.onChangeAlertRepeat(e.target.value, key)}
                                                                onBlur={(e) => this.onChangeAlertRepeatCounter(e.target.value, maintenanceInfoList[key].counter , key)}
                                                                // onBlur={(e) => this.onChangeAlertRepeatCounter(e.target.value, key)}
                                                            />
                                                        </td>
                                                        <td>
                                                           {maintenanceInfoList[key].measure_unit || 'วัน'}
                                                        </td>
                                                        <td>
                                                            <input
                                                                style={{background: 'rgba(255,255,255,0.4)', border:'none',  textAlign: 'center'}}
                                                                name="counter"
                                                                className="form-control"
                                                                type="text"
                                                                defaultValue={maintenanceInfoList[key].counter}
                                                                // onBlur={(e) => this.onChangeCounter(e.target.value, key)}
                                                                onBlur={(e) => this.onChangeAlertRepeatCounter(maintenanceInfoList[key].alert_repeat, e.target.value, key)}
                                                                // onBlur={(e) => this.onChangeAlertRepeatCounter(e.target.value, key)}
                                                            />
                                                        </td>
                                                        <td>
                                                            {maintenanceInfoList[key].measure_unit || 'วัน'}
                                                        </td>
                                                        <td>
                                                            <input
                                                                style={{background: 'rgba(255,255,255,0.4)', border:'none',  textAlign: 'center'}}
                                                                name="nextAlertWhen"
                                                                className="form-control"
                                                                type="text"
                                                                disabled
                                                                // value={data.alert_repeat - data.counter}
                                                                value={data.next_alert_when}
                                                            />
                                                        </td>
                                                        <td>
                                                            {maintenanceInfoList[key].measure_unit || 'วัน'}
                                                        </td>
                                                        <td>
                                                            <input
                                                                style={{background: 'rgba(255,255,255,0.4)', border:'none',  textAlign: 'center'}}
                                                                name="remark"
                                                                className="form-control"
                                                                type="text"
                                                                defaultValue={data.remark || ''}
                                                                onChange={(e) => this.onChangeRemark(e.target.value, key)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                name="mailAlert"
                                                                className="form-control"
                                                                type="checkbox"
                                                                defaultChecked={maintenanceInfoList[key].is_email_alert}
                                                                onChange={(e) => this.onChangeMailAlert(e.target.checked, key)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                name="lineAlert"
                                                                className="form-control"
                                                                type="checkbox"
                                                                defaultChecked={maintenanceInfoList[key].is_line_alert}
                                                                onChange={(e) => this.onChangeLineAlert(e.target.checked, key)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <button
                                                                className="btn btn-danger btn-xs"
                                                                data-title="Delete"
                                                                data-toggle="modal"
                                                                data-backdrop="static"
                                                                data-keyboard="false"
                                                                onClick={() => this.onClickDeleteRow(key)}>
                                                                <span className="fa fa-trash" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="row" style={{ float: 'right' }}>
                                    <div >
                                        <input type="button" className="btn btn-primary" value={t('ตกลง')} onClick={() => this.onClickSubmit()}/>
                                    </div>
                                    <div className="col-md-1">
                                        <button
                                            type="button"
                                            className="btn btn-warning"
                                            id="btsave-template"
                                            onClick={() => this.onClickSaveTemplate()}>
                                            <i className="fa fa-fw fa-plus" />{t('บันทึกเป็น Template')}
                                        </button>
                                    </div>
                            </div>
                        </div>
                    <div className="card-body">
                        <div className=" mx-auto">
                            <div className="col-md-12 table-responsive">
                                <h3>
                                    <i className="fa fa-history fa-lg grey"></i>
                                    {t('ประวัติการ Reset 20 รายการล่าสุด')}
                                </h3>
                                <table className="table table-bordred table-striped table-hover " style={{fontSize: '14px'}}>
                                    <thead >
                                    <tr>
                                        <th style={{width:'20px'}}>#</th>
                                        <th style={{width:'150px', textAlign: 'center'}}>{t('รายการ')}</th>
                                        <th style={{width:'150px', textAlign: 'center'}}>{t('วัดตาม')}</th>
                                        <th style={{width:'80px', textAlign: 'center'}}>{t('แจ้งทุกๆ')}</th>
                                        <th style={{width:'80px', textAlign: 'center'}}>{t('ค่า Reset')}</th>
                                        <th style={{width:'80px', textAlign: 'center'}}>{t('เมื่อ')}</th>
                                    </tr>
                                    </thead>
                                <tbody>
                                { alertHistory &&
                                    alertHistory.map((data, key) => {
                                    return (
                                            <tr key={`alertHistory_${key}`} style={{textAlign: 'center'}}>
                                                <td>{key + 1}</td>
                                                <td>
                                                    {alertHistory[key].ma_name}
                                                </td>
                                                <td>
                                                    {alertHistory[key].measure_type}
                                                </td>
                                                <td>
                                                    {alertHistory[key].alert_repeat}
                                                </td>
                                                <td>
                                                    {alertHistory[key].alert_when}
                                                </td>
                                                <td>
                                                    {alertHistory[key].last_alert_dtm}
                                                </td>
                                            </tr>
                                         )
                                    })
                                }
                                </tbody>
                            </table>
                            <div>
                                {!isMoveData &&
                                    <button
                                        type="button"
                                        className="btn btn-warning"
                                        id="btn-move-init"
                                        onClick={() => this.onClickMoveData()}>
                                        <i className="fa fa-share">{''}</i>{t('ย้ายข้อมูลไปเครื่องอื่น')}
                                    </button>
                                }
                                {isMoveData &&
                                    <div className="row">
                                        <div className="col-md-1 col-sm-1 col-4" style={{marginTop: 'auto', textAlign: 'right'}}>
                                            <label>{t('ย้ายไปที่')}</label>
                                        </div>
                                        <div style={{fontSize: '14px'}} className="col-md-3 col-sm-3 col-7">
                                                <Select
                                                    value={selectedDeviceMoveData}
                                                    onChange={this.handleChangeMoveData}
                                                    options={dataListMoveData}
                                                    placeholder={t('เลือกเลขทะเบียนรถ')}
                                                />
                                        </div>
                                        <div className="col-md-3 col-sm-3 col-5">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={() => this.onSubmitMoveData(selectedDeviceMoveData)}>
                                                    <i className="fa fa-check">{''}</i>
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-danger"
                                                    onClick={() => this.setState({isMoveData: false})}>
                                                    <i className="fas fa-times" >{''}</i>
                                                </button>
                                        </div>
                                    </div>
                                }
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                { isSaveTemplate &&
                <div className="modal-confirm" style={{display:'block'}} >
                    <div className="modal-dialog modal-dialog-centered" style={{top: -350}}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title custom_align" id="Heading">
                                    <i className="fa fa-cog fa-fw"></i>
                                    {t('บันทึกแม่แบบ')}
                                </h4>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-hidden="true"
                                    style={{padding: 0, margin: 0, position: 'inherit'}}
                                    onClick={() => this.setState({isSaveTemplate: false})}>
                                    <span className="fa fa-times" aria-hidden="true" />
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group row">
                                    <label htmlFor="example-text-input " className="col-md-3 text-right" >{t('ชื่อแม่แบบ')}</label>
                                    <div className="col-md-9">
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="name"
                                            onChange={(e) => this.setState({ templateName: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer ">
                                <button className="btn btn-primary" onClick={() => this.onSubmitNewTemplate()} >{t('บันทึก')}</button>
                                <button className="btn btn-danger" onClick={() => this.setState({isSaveTemplate: false})}>{t('ยกเลิก')}</button>
                            </div>
                        </div>

                    </div>
                </div>
                }
            </div>
        );
    }
}

MaintenanceInformation.defaultProps = {
    carNumber: {}
}

MaintenanceInformation.propTypes = {
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    isAddAlertMA: PropTypes.bool.isRequired,
    onClickAddAlertMA: PropTypes.func.isRequired,
    carNumber: PropTypes.object
}

export default withNamespaces('Menubar')(MaintenanceInformation);



// WEBPACK FOOTER //
// ./src/app/view/components/Maintenance/MaintenanceInformation.js